import {
  Home, Building2, Warehouse, Hotel,
  Zap, Wrench, Shield, RefreshCw, Smartphone,
  Thermometer, Droplets, UtensilsCrossed,
  Lock, Phone, Check, X, ChevronDown, ChevronRight,
  Star, CheckCircle, ArrowRight, MapPin, ShieldCheck,
  ClipboardList,
} from 'lucide-react';

const MAP = {
  Home, Building2, Warehouse, Hotel,
  Zap, Wrench, Shield, RefreshCw, Smartphone,
  Thermometer, Droplets, UtensilsCrossed,
  Lock, Phone, Check, X, ChevronDown, ChevronRight,
  Star, CheckCircle, ArrowRight, MapPin, ShieldCheck,
  ClipboardList,
};

export default function Icon({ name, size = 18, color, strokeWidth = 2, className, style }) {
  const C = MAP[name];
  if (!C) return null;
  return <C size={size} color={color} strokeWidth={strokeWidth} className={className} style={style} />;
}
